<template>
  <div v-if="category">
    <v-card>
      <v-card-title>
        {{ category.name }}
      </v-card-title>
      <v-card-subtitle class="caption">
        <v-row>
          <v-col cols="auto"> <span class="font-weight-bold">Id</span> {{ category.id }} </v-col>
          <v-col cols="auto">
            <span class="font-weight-bold">Ex. Id</span>
            {{ category.externalId }}
          </v-col>
          <v-col cols="auto">
            <span class="font-weight-bold">Slug</span> {{ category.urlSegment }}
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-divider />
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="category.name"
                label="Name"
                :rules="[$rules.required]"
                outlined
                hide-details="auto"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="category.namePlural"
                label="Plural Name"
                :rules="[$rules.required]"
                outlined
                hide-details="auto"
              />
            </v-col>

            <v-col
              v-if="category.type"
              cols="12"
            >
              <v-select
                v-model="category.type.id"
                :items="category_types"
                item-text="name"
                item-value="id"
                label="Type"
                :rules="[$rules.required]"
                outlined
                hide-details="auto"
              />
            </v-col>

            <v-col
              v-if="category.parentCategory"
              cols="12"
            >
              <v-select
                v-model="category.parentCategory.id"
                :items="parent_categories"
                item-text="name"
                item-value="id"
                label="Parent Category"
                outlined
                hide-details
              />
            </v-col>

            <v-col
              v-if="category.popularity"
              cols="12"
            >
              <v-select
                v-model="category.popularity.id"
                label="Popularity"
                :items="popularity"
                :rules="[$rules.required]"
                outlined
                hide-details="auto"
                item-value="id"
                item-text="name"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="category.iconSvg"
                label="Icon Svg"
                :rules="[$rules.required]"
                outlined
                hide-details="auto"
              >
                <template #append>
                  <div v-html="category.iconSvg" />
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                v-model="category.description"
                label="Internal Description"
                outlined
                hide-details="auto"
                auto-grow
                rows="1"
              />
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="category.groupId"
                label="Group"
                :items="groups"
                outlined
                hide-details="auto"
                item-value="id"
                item-text="name"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <ImageUpload
                height="120"
                title="Lifestyle Image"
                :url="category.lifestyleImageUrl"
                @save="saveImage('lifestyle', $event)"
              />
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <ImageUpload
                height="120"
                title="Print Image"
                :url="category.printImageUrl"
                @save="saveImage('print', $event)"
              />
            </v-col>
            <v-col cols="12">
              <div class="text-caption font-italic">
                *** Images should be 670px wide x 495px tall
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-text>
        <v-btn
          color="primary"
          :loading="saving"
          block
          @click="save"
        >
          Save
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ImageUpload from '@/components/common/ImageUpload';
import { mapGetters } from 'vuex';
export default {
  name: 'EditCategory',

  components: { ImageUpload },

  data() {
    return {
      enableEdit: false,
      loading: false,
      valid: false,
      saving: false,
      savingLifestyleImage: false,
      savingPrintImage: false
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
    category: {
      get() {
        return this.$store.getters['categories/edit_category'];
      },
      set(val) {
        this.$store.dispatch('categories/edit', val);
      }
    },
    ...mapGetters({
      category_types: 'lookup/category_types',
      parent_categories: 'lookup/parent_categories',
      popularity: 'lookup/popularity',
      groups: 'lookup/category_groups'
    })
  },

  watch: {
    id(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        this.loadData();
      }
    }
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch('lookup/getCategories'),
        this.$store.dispatch('lookup/getProducts'),
        this.$store.dispatch('categories/getCategory', this.id),
        this.$store.dispatch('lookup/getDesignGroups'),
        this.$store.dispatch('lookup/getIndustries'),
        this.$store.dispatch('lookup/getTopics')
      ])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleEdit() {
      this.enableEdit = !this.enableEdit;
      this.$refs.form.validate();
    },

    async save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      this.$store
        .dispatch('categories/update', this.category)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },

    async saveImage(type, e) {
      this.savingPrintImage = true;
      this.$store
        .dispatch(type === 'print' ? 'categories/setPrintImage' : 'categories/setLifestyleImage', {
          categoryId: this.category.id,
          file: e.target.files[0]
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.savingPrintImage = false;
        });
    }
  }
};
</script>
